import { faPencilAlt as solidPencilAlt } from "@jewlr/pro-solid-svg-icons/faPencilAlt"
import { faTrash as solidTrash } from "@jewlr/pro-solid-svg-icons/faTrash"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { updateChoice, trackSlide } from "areas/product/store/actions"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"
import StorageHelper from "helpers/local-storage-cache"
import { removePref } from "helpers/user-prefs"

import ImageUploadBtn from "../image-upload-btn"

const EditBtn = (props) => (
  <Button className="text-link text-12 mt-8 p-16" {...props} />
)

const EditSpan = (props) => <span className="pl-3" {...props} />

const InternalImageWizardOptions = ({
  data,
  handwritingEngraving,
  imageState,
  imageUrl,
  photoDescription,
  photoTitle,
  openImageUploadModal,
  setChoice,
}) => {
  if (!data || data.disabled) {
    return null
  }

  return (
    <div
      className="mb-10 p-10"
      data-hashid={data.option.name}
      data-label={data.option.display_label}
      data-pref={data.pref}
      data-summary-field={data.option.display_label}
    >
      {imageState == "SHOW" ? (
        <div data-pref={data.pref}>
          <div
            className="h-(--base-height) tablet:h-(--tablet-height) w-(--base-width) tablet:w-(--tablet-width) relative float-right cursor-pointer overflow-hidden"
            data-pref={data.pref}
            onClick={() => {
              openImageUploadModal()
            }}
            style={{
              "--base-height": "135px",
              "--base-width": "52%",
              "--tablet-height": "145px",
              "--tablet-width": "54%",
            }}
          >
            <Image
              alt="Photo preview"
              className="float-right"
              data-cy={`preview-${data.pref}`}
              data-pref={data.pref}
              id={`${data.option.name}_preview_img`}
              src={
                imageUrl || require("images/product/photo_pendant/default.jpg")
              }
              style={{ height: "80%" }}
            />
          </div>
          <div className="p-10">
            <p className="text-grey-65 text-14 tracking-half mb-14 mt-6">
              {photoTitle}
            </p>
            <p className="text-12">{photoDescription}</p>
            <div className="flex flex-wrap">
              <EditBtn
                data-pref={data.pref}
                onClick={() => {
                  openImageUploadModal()
                }}
              >
                <FontAwesomeIcon icon={solidPencilAlt} />
                <EditSpan>Modify</EditSpan>
              </EditBtn>
              <EditBtn
                data-pref={data.pref}
                onClick={() => {
                  const pref = data.pref
                  const width = data.cropper.aspect_ratio_width
                  const height = data.cropper.aspect_ratio_height
                  const cacheImageKey = `image-${pref}-${width}-${height}`
                  const cacheCropperKey = `cropper-${pref}-${width}-${height}`
                  StorageHelper.remove(cacheImageKey)
                  StorageHelper.remove(cacheCropperKey)
                  removePref(`${pref}_${width}_${height}`)
                  setChoice(pref, {
                    photoUploaded: false,
                    value: "",
                  })
                }}
              >
                <FontAwesomeIcon icon={solidTrash} />
                <EditSpan>Remove</EditSpan>
              </EditBtn>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-14 tracking-half text-center">
          {/* e.g. JWLN0758 */}
          {handwritingEngraving && (
            <p className="text-14 tablet:text-12 leading-16 tablet:leading-14 mb-30 tablet:mb-20 text-left font-medium">
              We use your image of a handwritten message to engrave your{" "}
              {jewlr_t("jewelry")}.{" "}
              <Button
                className="text-primary"
                onClick={() => {
                  openModal(`#pendant-upload-${data.pref}-tips`)
                }}
                text
                underline
              >
                Read image tips for best results.
              </Button>
            </p>
          )}
          <ImageUploadBtn pref={data.pref} />
          {/*end pendant upload area*/}
          {/*Pendant photo preview content*/}
        </div>
      )}
    </div>
  )
}

const getImageUrl = (data, display) => {
  if (display && display.image) {
    return display.image
  }
  if (data) {
    return require("images/product/photo_pendant/default.jpg")
  }
  return ""
}

const mapStateToProps = (state, ownProps) => {
  let data = state.wizard.data[ownProps.pref]
  let display = state.display[ownProps.pref] || {}
  let choices = state.choices[ownProps.pref]
  let imageState =
    choices && choices.value && choices.value.startsWith("user_uploads/")
      ? "SHOW"
      : "CHOOSE"
  let productType = state.wizard.description.product_type?.toLowerCase()
  let photoTitle = `YOUR ${productType.toUpperCase()} IMAGE`
  let photoDescription = `Your personal photo will be printed onto your ${productType}.`
  if (data?.option?.display_labels?.photo_title)
    photoTitle = data.option.display_labels.photo_title
  if (data?.option?.display_labels?.photo_description)
    photoDescription = data.option.display_labels.photo_description
  const handwritingEngraving =
    ownProps.pref && state.wizard.data[ownProps.pref]?.handwriting_engraving
  return {
    adminMode: state.wizard.adminMode || false,
    data,
    display: state.display,
    handwritingEngraving,
    imageState,
    imageUrl: getImageUrl(data, display),
    isMobile: state.browser.is.mobile,
    photoDescription,
    photoTitle,
    productType,
    wizardData: state.wizard.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { wizardData } = stateProps
  const { dispatch } = dispatchProps
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    openImageUploadModal: () => {
      const pref = stateProps.data?.pref || "img1"
      const iwo = wizardData[pref]
      if (iwo?.track_slide) {
        dispatch(trackSlide(iwo.track_slide))
      }
      openModal(`#pendant-upload-${pref}`)
    },
    setChoice: (pref, data) => {
      dispatch(updateChoice(pref, data, true))
      try {
        if (typeof ownProps.callback !== "undefined" && ownProps.callback) {
          ownProps.callback()
        }
      } catch (error) {
        console.log("CALLBACK ERROR:", error)
      }
    },
  }
}

InternalImageWizardOptions.propTypes = {
  data: PropTypes.object,
  handwritingEngraving: PropTypes.bool,
  imageState: PropTypes.string,
  imageUrl: PropTypes.string,
  openImageUploadModal: PropTypes.func,
  photoDescription: PropTypes.string,
  photoTitle: PropTypes.string,
  setChoice: PropTypes.func,
}

const ImageWizardOptions = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalImageWizardOptions)

export default ImageWizardOptions
